import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {
    CompleteIconActive,
    ReopenIconActive,
    ArchiveIconActive,
    UnarchiveIconActive,
    CompleteIconDisabled,
    ReopenIconDisabled,
    ArchiveIconDisabled,
    UnarchiveIconDisabled
 } from './../../../assets/icons.jsx';
import './quick-action-buttons.scss';

const ButtonWrapperNew = ({
    data,
    selectedData,
    buttonState,
    callback,
    canEdit
}) => {
    const [breakpoint, setBreakpoint] = useState(window.innerWidth < 1440);

    // Handles clicking the complete button beside filter when a project is selected
    const onSelectComplete = () => {
      let tempArr = data.filter((project) => {
        return (selectedData.includes(project.Id))
      })

      callback({type: "projectsToEdit", payload: tempArr})
      callback({type: "actionObj", payload: {
        actiontype: "Complete",
        status: 2
      }})

      callback({type: "showPopup", payload: true})
    }

    // Handles clicking the archive button beside filter when a project is selected
    const onSelectArchive = () => {
      let tempArr = data.filter((project) => {
        return (selectedData.includes(project.Id))
      })

      callback({type: "projectsToEdit", payload: tempArr})
      callback({type: "actionObj", payload: {
        actiontype: "Archive",
        status: 0
      }})

      callback({type: "showPopup", payload: true})
    }

    // Handles clicking the unarchive button beside filter when a project is selected
    const onSelectReopen = (e) => {
      let tempArr = data.filter((project) => {
        return (selectedData.includes(project.Id))
      })

      callback({type: "projectsToEdit", payload: tempArr})
      callback({type: "actionObj", payload: {
        actiontype: "Active",
        status: 1,
        popupLabel: (e.currentTarget.getAttribute('btnname') === "Reopen" ? "Reopen" : "Unarchive")
      }})

      callback({type: "showPopup", payload: true})
    }

    const setButtonVisibility = (invalidStatuses, type) => {
        for (let projectId in selectedData) {
            const project = data.find(project => project.Id === selectedData[projectId]);
            if (project) {
                const isValidStatus = invalidStatuses?.indexOf(project.StrStatus) === -1;
                const conditionForCompletion = canEdit(project);

                if (isValidStatus && conditionForCompletion) {
                    callback({ type, payload: true });
                } else {
                    callback({ type, payload: false });
                    break;
                }
            } else {
                callback({type, payload: false})
                break;
            }

        }
    };

    // Completed button only visible for ACTIVE only
    useEffect(() => {
      setButtonVisibility(["Completed", "Archived"], "complete");
      setButtonVisibility(["Active", "Archived"], "reopen");
      setButtonVisibility(["Archived"], "archive");
      setButtonVisibility(["Active", "Completed"], "unarchive");
    }, [selectedData])

    const atBreakpoint = () => {
      setBreakpoint(window.innerWidth < 1440)
    }

    const setDisplay = () => {
      return breakpoint ? "" : "d-none"
    }

    useEffect(() => {
        window.addEventListener("resize", atBreakpoint);
        return () => {
            window.removeEventListener("resize", atBreakpoint);
        }
    }, [])

    return (
        <div className="quick-action-btn-wrapper">
            {   buttonState.complete && selectedData.length > 0 ?
                <OverlayTrigger
                    placement="bottom"
                    overlay={
                        <Tooltip className={setDisplay()}>Complete</Tooltip>
                    }
                >
                    <span className="d-inline-block p-0">
                        <button
                            className="btn-icon1 complete-blue"
                            btnName="Complete"
                            onClick={() => onSelectComplete()}
                        >
                            <img src={CompleteIconActive} alt="Complete"/>
                            <span>Complete</span>
                        </button>
                    </span>
                </OverlayTrigger>
            :
                selectedData.length > 0 &&
                <OverlayTrigger
                    placement="bottom"
                    overlay={
                        <Tooltip className={setDisplay()}>Complete</Tooltip>
                    }
                >
                    <span className="d-inline-block p-0">
                        <button
                            className="btn-icon1 complete-blue mx-auto"
                            style={{ pointerEvents: 'none' }}
                            btnName="Complete"
                            onClick={() => onSelectComplete()}
                            disabled
                        >
                            <img src={CompleteIconDisabled} alt="Complete"/>
                            <span className="disabled-text">Complete</span>
                        </button>
                    </span>
                </OverlayTrigger>
            }
            {   buttonState.reopen && selectedData.length > 0 ?
                <OverlayTrigger
                    placement="bottom"
                    overlay={
                        <Tooltip className={setDisplay()}>Reopen</Tooltip>
                    }>
                    <span className="d-inline-block p-0">
                        <button
                            className="btn-icon1 reopen-blue"
                            btnName="Reopen"
                            onClick={(e) => onSelectReopen(e)}
                        >
                            <img src={ReopenIconActive} alt="Reopen"/>
                            <span>Reopen</span>
                        </button>
                    </span>
                </OverlayTrigger>
            :
                selectedData.length > 0 &&
                <OverlayTrigger
                    placement="bottom"
                    overlay={
                        <Tooltip className={setDisplay()}>Reopen</Tooltip>
                    }
                >
                <span className="d-inline-block p-0 ">
                    <button
                        className="btn-icon1 reopen-blue mx-auto"
                        style={{ pointerEvents: 'none' }}
                        btnName="Reopen"
                        onClick={(e) => onSelectReopen(e)}
                        disabled
                    >
                        <img src={ReopenIconDisabled} alt="Reopen"/>
                        <span className="disabled-text">Reopen</span>
                    </button>
                </span>
                </OverlayTrigger>
            }

            {   buttonState.archive && selectedData.length > 0 ?
                <OverlayTrigger
                    placement="bottom"
                    overlay={
                        <Tooltip className={setDisplay()}>Archive</Tooltip>
                    }
                >
                <span className="d-inline-block p-0 ">
                    <button
                        className="btn-icon1 archive-blue"
                        btnName="Archive"
                        onClick={() => onSelectArchive()}
                    >
                        <img src={ArchiveIconActive} alt="Archive"/>
                        <span>Archive</span>
                    </button>
                </span>
                </OverlayTrigger>
            :
                selectedData.length > 0 &&
                <OverlayTrigger
                    placement="bottom"
                    overlay={
                        <Tooltip className={setDisplay()}>Archive</Tooltip>
                    }
                >
                <span className="d-inline-block p-0">
                    <button
                        className="btn-icon1 archive-blue mx-auto"
                        btnName="Archive"
                        style={{ pointerEvents: 'none' }}
                        onClick={() => onSelectArchive()}
                        disabled
                    >
                        <img src={ArchiveIconDisabled} alt="Archive" />
                        <span className="disabled-text">Archive</span>
                    </button>
                </span>
                </OverlayTrigger>
            }
            {   buttonState.unarchive && selectedData.length > 0 ?
                <OverlayTrigger
                    placement="bottom"
                    overlay={
                        <Tooltip className={setDisplay()}>Unarchive</Tooltip>
                    }
                >
                <span className="d-inline-block p-0 ">
                    <button
                        className="btn-icon1 unarchive-blue"
                        btnName="Unarchive"
                        onClick={(e) => onSelectReopen(e)}              // Reuse the re-open functionality since the projects go from Archived -> Active
                    >
                        <img src={UnarchiveIconActive} alt="Unarchive" />
                        <span>Unarchive</span>
                    </button>
                </span>
                </OverlayTrigger>
            :
                selectedData.length > 0 &&
                <OverlayTrigger
                    placement="bottom"
                    overlay={
                        <Tooltip className={setDisplay()}>Unarchive</Tooltip>
                    }
                >
                <span className="d-inline-block p-0">
                    <button
                        className="btn-icon1 unarchive-blue mx-auto"
                        btnName="Unarchive"
                        style={{ pointerEvents: 'none' }}
                        onClick={(e) => onSelectReopen(e)}              // Reuse the re-open functionality since the projects go from Archived -> Active
                        disabled
                    >
                        <img src={UnarchiveIconDisabled} alt="Unarchive"/>
                        <span className="disabled-text">Unarchive</span>
                    </button>
                </span>
                </OverlayTrigger>
            }
        </div>
    )
}

ButtonWrapperNew.propTypes = {
    data: PropTypes.array.isRequired,
    selectedData: PropTypes.array,
    buttonState: PropTypes.object.isRequired,
    callback: PropTypes.func,
    canEdit: PropTypes.func,
};

export default ButtonWrapperNew;
